import React from 'react';
import { TextField } from '../TextField';
export var DatepickerInput = React.forwardRef(function (props, ref) {
  return React.createElement(TextField, Object.assign({}, props, {
    readOnly: true,
    inputRef: ref
  }));
});
DatepickerInput.displayName = 'DatepickerInput';